// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headerText":"styles__headerText__1n9xg"};